module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/write-97c62941dd789374119832d0d7d42914.svg";